
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { THistory_Table } from "@/models/data_history";
import {
  DOCUMENT_EDIT_HISTORICAL_TYPE_VALUE,
  MOVE_TO_PROGRESS_STEP_HISTORICAL_TYPE_VALUE,
  REPORT_GENERATION_HISTORICAL_TYPE_VALUE,
  CASE_DECISION_HISTORICAL_TYPE_VALUE,
} from "@/constants/dataHistory";

const VALUE_SECTION = "section";
const VALUE_BEFORE = "before";
const VALUE_AFTER = "after";
const VALUE_ACTION_BY = "actionBy";
const VALUE_DATE = "date";

const CLASS_ROW_DIVIDER = "row-divider";
const CLASS_HIGHLIGHT = "highlight";
const CLASS_LOOP = "loop";
const CLASS_HEIGHT_0 = "height-0";
const CLASS_HEIGHT_1 = "height-1";
const CLASS_HEIGHT_2 = "height-2";
const CLASS_HEIGHT_3 = "height-3";

const ROW_DIVIDER_COL_SPAN = "3";

@Component({})
export default class DataHistory extends Vue {
  @Prop({ type: Array, default: () => [] }) readonly historyItems!: THistory_Table[];

  headers = [
    {
      text: this.$t("table.headers.section"),
      value: VALUE_SECTION,
      slot: true,
    },
    {
      text: this.$t("table.headers.before"),
      value: VALUE_BEFORE,
      slot: true,
    },
    {
      text: this.$t("table.headers.after"),
      value: VALUE_AFTER,
      slot: true,
    },
    {
      text: this.$t("table.headers.actionBy"),
      value: VALUE_ACTION_BY,
      filterable: true,
    },
    {
      text: this.$t("table.headers.date"),
      value: VALUE_DATE,
      sortable: true,
      sortBy: "date",
    },
  ];

  isDividerRow(item) {
    const types = [
      MOVE_TO_PROGRESS_STEP_HISTORICAL_TYPE_VALUE,
      REPORT_GENERATION_HISTORICAL_TYPE_VALUE,
      CASE_DECISION_HISTORICAL_TYPE_VALUE,
    ];

    return types.includes(item.historicalValueType);
  }

  isDocumentRow(item) {
    const types = [DOCUMENT_EDIT_HISTORICAL_TYPE_VALUE];

    return types.includes(item.historicalValueType);
  }

  loopClass(value: boolean): string {
    return value ? CLASS_LOOP : "";
  }

  highlightClass(item: any, index: number): string {
    const { beforeValue, afterValue } = item;

    return beforeValue[index] !== afterValue[index] ? CLASS_HIGHLIGHT : "";
  }

  heightClass(item: THistory_Table, index: number) {
    const beforeValueLength = item.beforeValue[index].length / 30;
    const afterValueLength = item.afterValue[index].length / 30;

    if (beforeValueLength > 3 || afterValueLength > 3) return CLASS_HEIGHT_3;
    if (beforeValueLength > 2 || afterValueLength > 2) return CLASS_HEIGHT_2;
    if (beforeValueLength > 1 || afterValueLength > 1) return CLASS_HEIGHT_1;

    return CLASS_HEIGHT_0;
  }

  getDividerClasses(item) {
    const type = item.historicalValueType;

    return {
      [`${CLASS_ROW_DIVIDER}`]: true,
      [`${CLASS_ROW_DIVIDER}_centered`]: [
        CASE_DECISION_HISTORICAL_TYPE_VALUE,
        MOVE_TO_PROGRESS_STEP_HISTORICAL_TYPE_VALUE,
        REPORT_GENERATION_HISTORICAL_TYPE_VALUE,
      ].includes(type),
      [`${CLASS_ROW_DIVIDER}_highlighted`]: [
        CASE_DECISION_HISTORICAL_TYPE_VALUE,
        MOVE_TO_PROGRESS_STEP_HISTORICAL_TYPE_VALUE,
        REPORT_GENERATION_HISTORICAL_TYPE_VALUE,
      ].includes(type),
    };
  }

  moderateTable() {
    const tableEl = (this.$refs["table"] as Vue)?.$el as HTMLElement;

    const table = tableEl.querySelector(".data-history__table table");

    if (!table) return;

    const tableRows = table.querySelectorAll("tbody tr");

    if (!tableRows?.length) return;

    for (let i = 0; i < tableRows.length; i++) {
      const row = tableRows[i];

      const divider = row.querySelector(`.${CLASS_ROW_DIVIDER}`);

      if (!divider) continue;

      const cells = row.querySelectorAll("td");

      if (!cells?.length) continue;

      cells[0].setAttribute("colspan", ROW_DIVIDER_COL_SPAN);

      row.removeChild(row?.children[2]);
      row.removeChild(row?.children[1]);
    }
  }

  @Watch("historyItems", { immediate: true, deep: true })
  historyItemsChange(items: any) {
    if (!items.length) return;

    this.$nextTick(() => {
      setTimeout(() => {
        this.moderateTable();
      }, 1);
    });
  }
}
